/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export const SysControlEnum = {
    PUT_SYSTEM_REBOOT: '/system/reboot',
    PUT_SYSTEM_HALT: '/system/halt',
    GET_SYSTEM_UPDATE_STATUS: '/system/update/status',
    GET_SYSTEM_UPDATE_STATUS_FORCE: '/system/update/status/force',
    PUT_SYSTEM_UPDATE: '/system/update',
    POST_SYSTEM_UPDATE: '/system/update',
    PUT_SYSTEM_UPDATE_MAJOR: '/system/update/majorversion',
    GET_SYSTEM_STATS: (params: string): string => {
        return `/system-stats${params}`;
    }
};
